import React, { Fragment, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import FormSection from '../formSectionNew';
import localization from 'assets/localization/localization';
import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';
import ButtonWithIcon from 'components/sales/buttons/buttonWithIcon/buttonWithIcon';
import { handleValidateObj } from 'constants/objValues/objvalues';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import Inventory from 'components/sales/inventory/inventory';
import { DatePickerInput } from 'rc-datepicker';
import { FormGroup } from 'react-bootstrap';
import FileUpload from 'components/sales/fileUpload/fileUpload';
import * as moment from 'moment';
import Loader from 'components/sales/Loader/loader';
import { toast } from 'react-toastify';

const Increament = ({
  data,
  handleValue,
  getTag,
  imageUploadUrl,
  getTagById,
  prefilledData
}) => {
 
  const [inputList, setInputList] = useState([]);
  const [duration, setDuration] = useState([{id:"yearly",name:"Yearly"}]);
  // const [duration, setDuration] = useState([{id:"quarterly",name:"Quarterly"},{id:"halfYearly",name:"Half Yearly"},{id:"yearly",name:"Yearly"}]);

  const [payData, setPayData] = useState();
  const [month, setMonth] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [contract_length, setContractLength] = useState(1);
  const [subscription_amount, setAmount] = useState(0);
  const [isEditData, setIsEditData] = useState(0);
  
  const [increament, setIncreamentData] = useState();
  const [prefilledList, setPrefilledListList] = useState([]);
  
  useEffect(() => {
    if (
      prefilledData?.increment_type !== undefined &&
      prefilledData?.increment_type !== null &&
      prefilledData?.increment_type !== ''
    ) {
      const {
        increment_type,
        duration,
        increament_amount,
        inc
      } = prefilledData;
      setIncreamentData({
        ...increament,
        increament_type: increment_type,
        increment_value: (increment_type == 'flat')
        ? 'Flat Value' 
        : increment_type == 'percentage'
        ? 'Percentage'
        : increment_type == 'no'
        ? 'No'
        : 'Non-Uniform',
        duration: duration,
        duration_value: (duration == 'quarterly')
        ? 'Quarterly'
        : (duration == 'halfYearly')
        ? 'Half Yearly'
        : (duration == 'yearly')
        ?'Yearly'
        :'',
        increament_amount: increament_amount
      });
      setPrefilledListList(inc);
      setIsEditData(1);
    }
    if (contract_length == undefined) {
      setContractLength(data?.commercialData?.contract_length);
    }
  }, [prefilledData]);
  
  const handleDateChange1 = (date, dateString) => {
    const selectedDate = dateString;
    // setInputList({
    //   ...inputList,
    //   adv_payment_date: selectedDate,
    // });
    // const list = [...inputList];
    //     list[index][name] = value;
    //     setInputList(list);
    
  };

    
    const handleDateChange = (e, index,name) => {
      const current_datetime = moment(e).format("YYYY-MM-DD");
      const list = [...inputList];
      list[index][name] = current_datetime;
      setInputList(list);
      
    };
    const handledropDownChange = (e, index,name) => {
      // console.log(e);
      const { value,id} = e;
      const list = [...inputList];
      list[index][name] = id;
      setInputList(list);
    };

    const handleInputChange = (e,index,name)=>{
      const list = [...inputList];
      list[index][name] = e.target.value ?? 0;
      setInputList(list);
    };

    const handleConstInput = (e, index,name) => {
      // console.log(e);
      const list = [...inputList];
      list[index][name] = e;
      setInputList(list);
    };
    
   
    const handleFormData = () => {
      // inc['input'] = inputList;
      if (inputList) {
        
        if (increament?.increament_type == 'flat' || increament?.increament_type == 'percentage') {
          // const incData = {
          //   duration: increament?.duration,
          //   value: increament?.increament_amount
          // };
          // console.log(increament?.duration);
          // console.log(increament?.increament_amount);
          if (
            increament?.duration && 
            increament?.increament_amount) {
            handleValue({
              "inc":increament,"input":inputList,
            });
          } else {
            handleValue({
              "inc":increament,"input":[],
            });
            // console.log('failed');
            // handleValue(null);
          }
        } else {
          handleValue({
            "inc":increament,"input":inputList,
          });
        }
      } else {
        handleValue(null);
      }
      // console.log(increament);
    };
  
  useEffect(() => {
    handleFormData();
  }, [inputList,increament]);


  useEffect(() => {
    setContractLength(data?.commercialData?.contract_length);
    setAmount(data?.commercialData?.subscription_amount);
    if(data?.commercialData?.payment_term_type == 3){
      setMonth(3); //quarter
    }else if(data?.commercialData?.payment_term_type == 4){
      setMonth(6); // half
    }
    else if(data?.commercialData?.payment_term_type == 5){
      setMonth(12); // 1 year
    }
    else{
      setMonth(1); // month
    }
    
  },[]);

  useEffect(() => {
    setIsLoading(true)
    if(increament != null && increament.increament_type == 'nonUniform'){
      const list = [...inputList];
      const list2 = [];
      if (contract_length == undefined) {
        setContractLength(data?.commercialData?.contract_length);
      }
      if (isEditData && prefilledList.length>0) {
        prefilledList.map((e, index) => (
          list2.push({"subscription_amounts" : e.subscription_amount})
        ));
        setInputList(list2);  
        setIsEditData(0);
      } else {
        {[...Array(Math.ceil(Number(contract_length)/month))].map((e, index) => (
          list.push({"subscription_amounts" : data.commercialData.subscription_amount}),
          setInputList(list)  
        ))}
      }
      
    } else {
      const list = [...inputList];
      list.splice(0, );
      setInputList(list)
    }
 
    setIsLoading(false)
  },[increament]);

    const incrementBody = () =>{
      if(increament != null && increament.increament_type == 'nonUniform'){
        return (
          <>
          {/* {month}{contract_length}{subscription_amount} */}
          {inputList.map((e, index) => (
             
  
            <div key={index}>
             
                <div className="col-12">
                <label> {localization.installmentAmt+` `+(index+1)+` In ₹`}<span style={{ color: 'red' }}>*</span>
                </label>
                
                <input
                    className="form-control"
                    name="subscription_amounts"
                    // placeholder={localization.installationCharge}
                    value={e.subscription_amounts}
                    onChange={e => handleInputChange(e, index,'subscription_amounts')}
                    required
                  />
                </div>
                </div>
           
          )
          )}
         
          </>
        );
      }else if(increament != null && (increament.increament_type == 'flat' || increament.increament_type == 'percentage')){
        return (
          <>
            <div className="col-6">

              <DropDownInput
                label={localization.duration}
                data={duration}
                required
                errorMsg={localization.requiredDuration}
                getIdValue={(val) =>{
                  setIncreamentData({
                    ...increament,
                    duration: val.id,
                  });
                  // handledropDownChange(val,i,'payment_mode');
                  }
                }
                value={increament?.duration_value}
                isStarRequired={true}
              />
            </div>
            <div className="col-6">
              <ConstantInput
                label={localization.increamentAmount +` ( `+ increament.increament_type +` ) `}
                required
                isStarRequired={true}
                errorMsg={localization.requiredIncAmt}
                handleChange={(val) =>
                  setIncreamentData({ ...increament, increament_amount: val })
                }
                value={increament?.increament_amount}
              />
            </div>
          </>
        );
      }
     
    };

  return (
    <Fragment>
      
      {( (data?.commercialData?.commercial_type_id === 6 || data?.commercialData?.commercial_type_id === 7) && 
      <FormSection title={localization.increament}>
        <div className="row">
        <Loader isLoading={isLoading} />
        <div className="col-5">
          <DropDownInput
                
            label={localization.typeIncreament}
            data={[
              { id: 'no', name: 'no' },
              { id: 'nonUniform', name: 'Non-Uniform' },
              { id: 'flat', name: 'Flat Value' },
              { id: 'percentage', name: 'Percentage' },
              
            ]}
            // required
            errorMsg={localization.typeIncreament}
            getIdValue={(val) =>{
              setIncreamentData({
                ...increament,
                increament_type: val.id,
                increment_value: val.name,
              });
              // handledropDownChange(val,i,'payment_mode');
              }
            }
            value={increament?.increment_value}
            isStarRequired={false}
          />
            
        </div>
        </div>
        
        <div className="row">
         
        {incrementBody()}
       
        </div>
       <br/>
      </FormSection>)
      }
      
    </Fragment>
  );
};
Increament.propTypes = {
  data: PropTypes.any,
  handleValue: PropTypes.func,
};
export default Increament;
